<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-4.mt-3.pb-3 {{ $tf("report.list.title") }}
  v-layout(:class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card.grey.lighten-4(width="100%")
      template(v-if="sortedReports && sortedReports.length > 0")
        v-list.overflow-x-hidden
          template(v-for='(report, index) in sortedReports')
            //- v-subheader(v-if="report.hasHeader") 
            v-list-tile.px-2(:key='report.id' avatar ripple :to="{name:'ReportController', params: {reportId: report.id}}")
              v-list-tile-avatar
                i.v-icon.white--text.material-icons.process-default-icon(:class="report.processKey")
              v-list-tile-content
                v-list-tile-title {{locale === 'kk' ? report.nameKaz : report.name}}
      template(v-if="sortedReports && sortedReports.length == 0")
        v-flex(xs12)
          div.nothing-right-div
            v-layout(align-center justify-center row fill-height)
              div.headline.grey--text.ta-c.px-5 {{ $tf("drawer.report.noPermission") }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import lodash from 'lodash'
import { getLocale } from '@/i18n'

export default {
  name: 'ReportList',

  data() {
    return {
      sortedReports: null,
    }
  },

  computed: {
    ...mapGetters({
      reports: 'report/reports',
    }),
    locale() {
      return getLocale()
    },
  },

  created() {
    this.getReports().then(() => {
      const reports = lodash.orderBy(this.reports, [
        item => item.processName,
        item => item.name,
      ], ['asc', 'asc'])

      let prevHeader = null
      reports.forEach((element) => {
        if (prevHeader !== element.processKey) {
          element.hasHeader = true
        } else {
          element.hasHeader = false
        }
        prevHeader = element.processKey
      })
      this.sortedReports = reports
    })
  },

  methods: {
    ...mapActions({
      getReports: 'report/getReports',
    }),
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/report/ReportList.vue